import axios from "../common/AuthInterceptor";
import authHeader from "./auth-header";

const MEDIA_CLIENT_API_URL = process.env.REACT_APP_API_URL + "/api/media-client";

const getMediaClients = (page = 0, size = 50, search = null, sortDirection = "ASC") => {
  let url = `${MEDIA_CLIENT_API_URL}?page=${page}&size=${size}&sortDirection=${sortDirection}`;
  if (search && search.trim() !== "") {
    url += `&search=${encodeURIComponent(search.trim())}`;
  }
  return axios.get(url, { headers: authHeader() });
};

const searchClients = (searchTerm) => {
  return axios.get(
    `${MEDIA_CLIENT_API_URL}/search-clients?searchTerm=${encodeURIComponent(searchTerm)}`,
    { headers: authHeader() }
  );
};

const createMediaClientFromPartsKick = (clientOid, storage) => {
  return axios.post(
    `${MEDIA_CLIENT_API_URL}/create-from-partskick`,
    { clientOid: clientOid, storage: storage },
    { headers: authHeader() }
  );
};

const createMediaClient = (clientData) => {
  return axios.post(
    `${MEDIA_CLIENT_API_URL}`,
    clientData,
    { headers: authHeader() }
  );
};

const updateClientStatus = (mediaClientId, statusId) => {
  return axios.put(
    `${MEDIA_CLIENT_API_URL}/${mediaClientId}/status`,
    { statusId: statusId },
    { headers: authHeader() }
  );
};

const getMediaClientById = (mediaClientId) => {
  return axios.get(
    `${MEDIA_CLIENT_API_URL}/${mediaClientId}`,
    { headers: authHeader() }
  );
};

const getAllCountries = () => {
  return axios.get(
    `${MEDIA_CLIENT_API_URL}/countries`,
    { headers: authHeader() }
  );
};

const getProvincesByCountry = (countryCode) => {
  return axios.get(
    `${MEDIA_CLIENT_API_URL}/provinces?countryCode=${encodeURIComponent(countryCode)}`,
    { headers: authHeader() }
  );
};

const getClientS3Sync = (mediaClientId) => {
  return axios.get(
    `${MEDIA_CLIENT_API_URL}/${mediaClientId}/s3-sync`,
    { headers: authHeader() }
  );
};

const updateClientS3Sync = (mediaClientId, syncData) => {
  return axios.put(
    `${MEDIA_CLIENT_API_URL}/${mediaClientId}/s3-sync`,
    syncData,
    { headers: authHeader() }
  );
};

const updateMediaClient = (mediaClientId, clientData) => {
  return axios.put(
    `${MEDIA_CLIENT_API_URL}/${mediaClientId}`,
    clientData,
    { headers: authHeader() }
  );
};

const updateClientFeatures = (mediaClientId, featuresData) => {
  return axios.put(
    `${MEDIA_CLIENT_API_URL}/${mediaClientId}/features`,
    featuresData,
    { headers: authHeader() }
  );
};

const generateCloudResources = (mediaClientId) => {
  return axios.post(
    `${MEDIA_CLIENT_API_URL}/${mediaClientId}/generate-cloud-resources`,
    {},
    { headers: authHeader() }
  );
};

const generateSubClientCloudResources = (mediaClientId) => {
  return axios.post(
    `${MEDIA_CLIENT_API_URL}/${mediaClientId}/generate-sub-client-cloud-resources`,
    {},
    { headers: authHeader() }
  );
};

const getClientS3Resources = (mediaClientId) => {
  return axios.get(
    `${MEDIA_CLIENT_API_URL}/${mediaClientId}/cloud-resources`,
    { headers: authHeader() }
  );
};

const deleteCloudResources = (mediaClientId) => {
  return axios.delete(
    `${MEDIA_CLIENT_API_URL}/${mediaClientId}/cloud-resources`,
    { headers: authHeader() }
  );
};

const deleteSubClientCloudResources = (mediaClientId) => {
  return axios.delete(
    `${MEDIA_CLIENT_API_URL}/${mediaClientId}/sub-client-cloud-resources`,
    { headers: authHeader() }
  );
};

const sendQRCode = (mediaClientId) => {
  return axios.post(
    `${MEDIA_CLIENT_API_URL}/${mediaClientId}/generate-qr-code`,
    {},
    { headers: authHeader() }
  );
};

const getEligibleParentClients = () => {
  return axios.get(
    `${MEDIA_CLIENT_API_URL}/eligible-parents`,
    { headers: authHeader() }
  );
};

const getParentClients = () => {
  return axios.get(
    `${MEDIA_CLIENT_API_URL}/parent-clients`,
    { headers: authHeader() }
  );
};

const hasChildClients = (mediaClientId) => {
  return axios.get(
    `${MEDIA_CLIENT_API_URL}/${mediaClientId}/has-children`,
    { headers: authHeader() }
  );
};

const getChildrenByParentId = (parentId, page = 0, size = 50, sortDirection = "ASC") => {
  let url = `${MEDIA_CLIENT_API_URL}/${parentId}/children?page=${page}&size=${size}&sortDirection=${sortDirection}`;
  return axios.get(url, { headers: authHeader() });
};

const getPhotobaseUsage = (page = 0, size = 50, search = null, orderBy = "clientName", sortDirection = "ASC") => {
  let url = `${MEDIA_CLIENT_API_URL}/photobase-usage?page=${page}&size=${size}&orderBy=${orderBy}&sortDirection=${sortDirection}`;
  if (search && search.trim() !== "") {
    url += `&search=${encodeURIComponent(search.trim())}`;
  }
  return axios.get(url, { headers: authHeader() });
};

const mediaClientService = {
  getMediaClients,
  searchClients,
  createMediaClientFromPartsKick,
  createMediaClient,
  updateClientStatus,
  getMediaClientById,
  updateMediaClient,
  getAllCountries,
  getProvincesByCountry,
  getClientS3Sync,
  updateClientS3Sync,
  generateCloudResources,
  generateSubClientCloudResources,
  getClientS3Resources,
  deleteCloudResources,
  deleteSubClientCloudResources,
  sendQRCode,
  getEligibleParentClients,
  getParentClients,
  hasChildClients,
  getChildrenByParentId,
  updateClientFeatures,
  getPhotobaseUsage
};

export default mediaClientService;

